<template>
  <div id="updata-box">
    <ul class="updata-tab">
      <router-link
        :class="{ act: $route.name === client.link }"
        v-for="client in clients"
        :key="client.terminal_type"
        @click="switchClient(client.terminal_type)"
        :to="{ name: client.link }"
        tag="li"
      >
        <i :class="['iconfont', 'icon-' + client.class]"></i>
        <span class="client-name">{{ client.name }}</span>
      </router-link>
    </ul>
    <div class="updata-body container">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: "UpdateLogWraper",
  data() {
    return {
      releases: [],
      clients: [
        {
          name: "Web版",
          class: "web",
          terminal_type: 2,
          link: "updatelog",
        },
        {
          name: "Windows版",
          class: "windows",
          terminal_type: 1,
          link: "updatelogWindows",
        },
        {
          name: "Android版",
          class: "android",
          terminal_type: 4,
          link: "updatelogAndroid",
        },
        {
          name: "iPhone/iPad版",
          class: "ios1",
          terminal_type: 3,
          link: "updatelogIphone",
        },
        {
          name: "Windows同步端(测试版)",
          class: "windows-tb",
          terminal_type: 6,
          link: "updatelogWindowsSync",
        },
        // {
        //   name: "Mac同步端",
        //   class: "ios-tb",
        //   terminal_type: 7,
        //   link: "updatelogIphoneSync",
        // },
        // { name: "Wechat版", class: "", terminal_type: 5, link: 'wechat' }
      ],
      query: {
        offset: 0,
        limit: 10,
        terminal_type: "2",
      },
    };
  },
  created() {
    this.$store.commit("SET_THEME", "版本信息");
  },
  methods: {
    switchClient(terminal_type) {
      this.query.terminal_type = terminal_type;
      this.clientReleases();
      this.clients.map((item) => {
        if (item.terminal_type === terminal_type) {
          item.show = true;
        } else {
          item.show = false;
        }
        return item;
      });
    },
  },
  mounted() {
    this.$nextTick(function () {
      var wh = $(window).height();
      var a = $("#header").height();
      var b = $("#footer").height();
      $("#updata-box").css("min-height", wh - a - b + "px");
    });
  },
};
</script>

<style scoped>
</style>